<template>
    <div class="gallery-modal" v-show="isOpen" style="display: block;">
        <div class="gallery-modal-inner">

            <span class="gallery-modal-close" @click="close">
                <svg class="close"><use xlink:href="#close"></use></svg>
            </span>

            <div class="gallery-modal-content" v-if="images.length">
                <div class="content">
                    <div class="content-count">
                        <span v-text="currentIndex + 1"></span> of <span v-text="images.length"></span>
                    </div>
                </div>
            </div>

            <div class="gallery-modal-image">
                <div class="gallery-images" v-if="images.length">
                    <VueSlickCarousel
                        v-bind="slickConfig"
                        ref="carousel"
                        @init="initCarousel">
                        <div class="img-wrap" v-for="(image, i) in images" :key="i">
                            <img :src="image" :alt="title">
                        </div>
                    </VueSlickCarousel>
                </div>

                <span class="gallery-modal-prev" @click="showPrev">
                    <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                </span>
                <span class="gallery-modal-next" @click="showNext">
                    <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                </span>
            </div>

        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
    components: { VueSlickCarousel },

    props: {
        title: { type: String, default: '' }
    },

    data() {
        return {
            isOpen: false,
            images: [],
            currentIndex: 0,
            slickConfig: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                fade: true,
                dots: true,
                initialSlide: 0,
            }
        }
    },

    created() {
        eventBus.$on('open-partner-gallery', data => {
            this.images = data.images
            this.currentIndex = data.index || 0
            this.isOpen = true
        })
    },

    methods: {
        initCarousel() {
            this.$nextTick(() => {
                if (this.$refs.carousel) {
                    this.$refs.carousel.goTo(this.currentIndex)
                }
            })
        },
        showNext() {
            if (this.currentIndex === this.images.length - 1) {
                this.currentIndex = 0
                this.$refs.carousel.goTo(0)
                return
            }
            this.currentIndex++
            this.$refs.carousel.next()
        },
        showPrev() {
            if (this.currentIndex === 0) {
                this.currentIndex = this.images.length - 1
                this.$refs.carousel.goTo(this.currentIndex)
                return
            }
            this.currentIndex--
            this.$refs.carousel.prev()
        },
        close() {
            this.isOpen = false
        }
    }
}
</script>

<style lang="scss" scoped>
.slick-slider {
    height: 100%;
}
</style>
